import { render, staticRenderFns } from "./AdminPromotionsExpandedWidget.vue?vue&type=template&id=1b1baa98"
import script from "./AdminPromotionsExpandedWidget.vue?vue&type=script&lang=js"
export * from "./AdminPromotionsExpandedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports